import { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import "../../../css/wallet/Token/ReceiveToken.css";
import "../../../css/wallet/Token/AddBankCard.css";
import { domain } from "../../Links/Links";
import axios from "axios";
import { getCookie } from "../../../App";

const BANK_PREFIXES = {
    '627381': { name: 'بانک انصار', logo: 'ansar.png' },
    '636214': { name: 'بانک آینده', logo: 'ayandeh.png' },
    '502938': { name: 'بانک دی', logo: 'day.png' },
    '627412': { name: 'بانک اقتصاد نوین', logo: 'eghtesad.png' },
    '505416': { name: 'بانک گردشگری', logo: 'gardeshgari.png' },
    '639599': { name: 'بانک قوامین', logo: 'ghavamin.png' },
    '505785': { name: 'بانک ایران زمین', logo: 'iranzamin.png' },
    '627488': { name: 'بانک کارآفرین', logo: 'karafarin.png' },
    '502910': { name: 'بانک کارآفرین', logo: 'karafarin.png' },
    '603770': { name: 'بانک کشاورزی', logo: 'keshavarzi.png' },
    '639217': { name: 'بانک کشاورزی', logo: 'keshavarzi.png' },
    '585947': { name: 'بانک خاورمیانه', logo: 'khavarmianeh.png' },
    '505809': { name: 'بانک خاورمیانه', logo: 'khavarmianeh.png' },
    '628023': { name: 'بانک مسکن', logo: 'maskan.png' },
    '639370': { name: 'بانک مهر اقتصاد', logo: 'mehreghtesad.png' },
    '603799': { name: 'بانک ملی', logo: 'meli.png' },
    '610433': { name: 'بانک ملت', logo: 'mellat.png' },
    '991975': { name: 'بانک ملت', logo: 'mellat.png' },
    '622106': { name: 'بانک پارسیان', logo: 'parsian.png' },
    '627884': { name: 'بانک پارسیان', logo: 'parsian.png' },
    '639194': { name: 'بانک پارسیان', logo: 'parsian.png' },
    '502229': { name: 'بانک پاسارگاد', logo: 'pasargad.png' },
    '639347': { name: 'بانک پاسارگاد', logo: 'pasargad.png' },
    '627760': { name: 'پست بانک', logo: 'postbank.png' },
    '589463': { name: 'بانک رفاه', logo: 'refah.png' },
    '504172': { name: 'بانک رسالت', logo: 'resalat.png' },
    '603769': { name: 'بانک صادرات', logo: 'saderat.png' },
    '621986': { name: 'بانک سامان', logo: 'saman.png' },
    '639607': { name: 'بانک سرمایه', logo: 'sarmaye.png' },
    '589210': { name: 'بانک سپه', logo: 'sepah.png' },
    '502806': { name: 'بانک شهر', logo: 'shahr.png' },
    '504706': { name: 'بانک شهر', logo: 'shahr.png' },
    '639346': { name: 'بانک سینا', logo: 'sina.png' },
    '585983': { name: 'بانک تجارت', logo: 'tejarat.png' },
    '627353': { name: 'بانک تجارت', logo: 'tejarat.png' },
    '628157': { name: 'موسسه اعتباری توسعه', logo: 'tosehe.png' },
};

function AddBankCard({ theme, setShowAddCard, onCardAdded }) {
    const { t } = useTranslation();
    const [formData, setFormData] = useState({
        card_number: "",
        bank_name: "",
        holder_name: "",
        sheba: "",
        is_default: false,
    });
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [detectedBank, setDetectedBank] = useState(null);
    const [cardNumberDisplay, setCardNumberDisplay] = useState("");
    const inputRef = useRef(null);

    const detectBank = (cardNumber) => {
        const cleanNumber = cardNumber.replace(/\s/g, '');
        if (cleanNumber.length < 6) {
            setDetectedBank(null);
            return;
        }

        const prefix = cleanNumber.substring(0, 6);
        const bank = BANK_PREFIXES[prefix];

        if (bank) {
            setDetectedBank(bank);
            setFormData(prev => ({
                ...prev,
                bank_name: bank.name
            }));
        } else {
            setDetectedBank(null);
            setFormData(prev => ({
                ...prev,
                bank_name: ""
            }));
        }
    };

    const formatCardNumber = (value) => {
        const clean = value.replace(/\s/g, '');
        const onlyNumbers = clean.replace(/\D/g, '');

        const truncated = onlyNumbers.slice(0, 16);

        const parts = [];
        for (let i = 0; i < truncated.length; i += 4) {
            parts.push(truncated.slice(i, i + 4));
        }

        return parts.join(' ');
    };

    const handleCardNumberChange = (e) => {
        const formatted = formatCardNumber(e.target.value);
        const cleanNumber = formatted.replace(/\s/g, '');

        setCardNumberDisplay(formatted);
        setFormData(prev => ({
            ...prev,
            card_number: cleanNumber
        }));

        if (cleanNumber.length >= 6) {
            detectBank(cleanNumber);
        } else {
            setDetectedBank(null);
        }
    };

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: type === "checkbox" ? checked : value
        }));
    };

    useEffect(() => {
        if (inputRef.current) {
            inputRef.current.focus();
        }
    }, []);


    const isFormComplete = () => {
        const cardNumberValid = formData.card_number.length === 16;
        const bankDetected = detectedBank !== null;
        const holderNameValid = formData.holder_name.trim().length >= 2;
        const shebaValid = () => {
            const cleanSheba = formData.sheba.replace(/\s/g, '').toUpperCase();
            return cleanSheba.startsWith('IR') && cleanSheba.length === 26;
        };
        return cardNumberValid && bankDetected && holderNameValid && shebaValid();
    };


    const handleSubmit = async (e) => {
        e.preventDefault();

        if (formData.card_number.length !== 16) {
            setError(t("Card number must be 16 digits"));
            return;
        }

        if (!detectedBank) {
            setError(t("Bank not recognized. Please check the card number."));
            return;
        }

        const cleanSheba = formData.sheba.replace(/\s/g, '').toUpperCase();
        if (!cleanSheba.startsWith('IR') || cleanSheba.length !== 26) {
            setError(t("Sheba number must start with IR and be 26 characters"));
            return;
        }

        setLoading(true);
        setError("");

        try {
            const submitData = {
                card_number: formData.card_number,
                bank_name: detectedBank.name,
                holder_name: formData.holder_name || formData.card_number,
                sheba: cleanSheba, 
                is_default: formData.is_default,
            };


            const { data } = await axios.post(
                domain + "/add_bank_card/", 
                submitData,
                {
                    withCredentials: true,
                    headers: {
                        "X-CSRFToken": getCookie("csrf_token"),
                        "Content-Type": "application/json",
                    },
                }
            );

            if (data.ok) {
                onCardAdded();
                setShowAddCard(false);
            } else {
                setError(data.error || data.message || t("An error occurred"));
            }

        } catch (error) {
            console.error(error);
            if (error.response) {
                setError(error.response.data.error || t("An error occurred"));
            } else {
                setError(t("Network error. Please try again."));
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="addBankCardOverlay" onClick={() => setShowAddCard(false)}>
            <div
                className={`addBankCardPopup ${theme}`}
                onClick={(e) => e.stopPropagation()}
            >
                <div className="addBankCardHeader">
                    <h3>{t("Add Bank Card")}</h3>
                    <button
                        className="closeButton"
                        onClick={() => setShowAddCard(false)}
                    >
                        ✕
                    </button>
                </div>

                <form onSubmit={handleSubmit} className="addBankCardForm">
                    <div className="input_div">
                        <label>{t("Card Number")}</label>
                        <div className="cardNumberInputWrapper">
                            <input
                                ref={inputRef}
                                type="text"
                                name="card_number"
                                value={cardNumberDisplay}
                                onChange={handleCardNumberChange}
                                maxLength="19"
                                placeholder="**** **** **** ****"
                                required
                                className={`input ${theme}`}
                                style={{direction: "ltr"}}
                            />
                            {detectedBank && (
                                <div className="bankInfo">
                                    <img
                                        src={`/banks/${detectedBank.logo}`}
                                        alt={detectedBank.name}
                                        className="bankLogo"
                                    />
                                    <span className="bankName">{detectedBank.name}</span>
                                </div>
                            )}
                        </div>
                    </div>

                    <div className="input_div">
                        <label>{t("Card Holder Name")}</label>
                        <input
                            type="text"
                            name="holder_name"
                            value={formData.holder_name}
                            onChange={handleChange}
                            placeholder={t("Card Holder Name")}
                            className={`input ${theme}`}
                        />
                    </div>

                    <div className="input_div">
                        <label>{t("Sheba Number")}</label>
                        <input
                            type="text"
                            name="sheba"
                            value={formData.sheba}
                            onChange={handleChange}
                            placeholder="IR123456789012345678901234"
                            className={`input ${theme}`}
                            maxLength="26"
                            style={{direction: "ltr"}}
                        />
                    </div>


                    {error && <div className="errorMessage">{error}</div>}

                    <button
                        type="submit"
                        className={`submit_button jjuahs32 ${theme} ${isFormComplete() ? 'active' : ''}`}
                        disabled={loading || !isFormComplete()}
                    >
                        {loading ? t("Saving...") : t("Save Card")}
                    </button>
                </form>
            </div>
        </div>
    );
}

export default AddBankCard;